/* unplugin-vue-components disabled */import script from "./cares.vue?vue&type=script&setup=true&lang=js"
export * from "./cares.vue?vue&type=script&setup=true&lang=js"

import "./cares.vue?vue&type=style&index=0&id=6a2d262e&scoped=true&lang=scss"

import exportComponent from "/Users/admin/Desktop/project/klb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a2d262e"]])

export default __exports__